import { LockKeyhole } from "lucide-react";
import type { ReactNode } from "react";
import { useApp } from "../context/AppContext";
import type { WorkspaceCapability } from "../lib/permissions";

export function WorkspacePermission({
  capability,
  children,
}: {
  capability: WorkspaceCapability;
  children: ReactNode;
}) {
  const { can, loading } = useApp();

  if (loading) {
    return (
      <div className="route-fallback" role="status">
        <span />
        Verificando papel no workspace…
      </div>
    );
  }

  if (!can(capability)) {
    return (
      <section className="empty-state" role="alert">
        <LockKeyhole />
        <h1>Acesso não disponível para este papel</h1>
        <p>
          A navegação aplica o papel carregado do workspace. A autorização
          efetiva continua sendo validada pelas RPCs e políticas RLS no
          Supabase.
        </p>
      </section>
    );
  }

  return children;
}
